export const formatBRL = (raw: string): string => {
  const digits = raw.replace(/\D/g, '')
  if (!digits) return ''
  return 'R$ ' + parseInt(digits, 10).toLocaleString('pt-BR')
}

export const onlyDigits = (value: string): string => value.replace(/\D/g, '')

export const minutesToTime = (totalMinutes: number): string => {
  const safe = Number.isFinite(totalMinutes) && totalMinutes > 0 ? totalMinutes : 0
  const hours = Math.floor(safe / 60)
  const minutes = safe % 60
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
}

export const timeToMinutes = (time: string): number => {
  const [hours, minutes] = time.split(':').map(Number)
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return 0
  return hours * 60 + minutes
}